import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../../core/axios/axiosInstance";
import { showToast } from "./ToastSlice";

/* ============================
   FETCH CAMPAIGNS
============================ */
export const fetchCampaigns = createAsyncThunk(
  "wabaCampaign/fetchCampaigns",
  async (payload, { rejectWithValue, getState }) => {
    try {
      const state = getState().wabaCampaign;
      const cacheKey = JSON.stringify({
        page: payload?.page || 1,
        limit: payload?.limit || 10,
        search: payload?.search || "",
      });
      const cached = state.cachedPages?.[cacheKey];
      if (!payload?.forceRefresh && cached) {
        return { campaigns: cached.data, count: cached.count, fromCache: true, cacheKey };
      }

      const res = await api.post("api/whatsapp/campaigns", payload);
      return {
        campaigns: res.data.campaigns || [],
        count: res.data.count || 0,
        fromCache: false,
        cacheKey,
      };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch campaigns"
      );
    }
  }
);

/* ============================
   ADD CAMPAIGN
============================ */
export const addCampaign = createAsyncThunk(
  "wabaCampaign/addCampaign",
  async (payload, { rejectWithValue }) => {
    try {
        
        
        const res = await api.post("api/whatsapp/send-campaign", payload);
        
      return res.data; // adjust if needed
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to add campaign"
      );
    }
  }
);

/* ============================
   DELETE CAMPAIGN
============================ */
export const deleteCampaign = createAsyncThunk(
  "wabaCampaign/deleteCampaign",
  async (campaignId, thunkAPI) => {
    try {
        console.log(campaignId,"campaignId");
        
      const response = await api.delete(
        `api/whatsapp/delete/campaigns/`,
    {
      data: {campaignId},
    });

      thunkAPI.dispatch(
        showToast({
          message: response.data.message,
          variant: "success",
        })
      );

      return campaignId;
    } catch (err) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || "Failed to delete campaign"
      );
    }
  }
);


/* ============================
   SLICE
============================ */
const wabaCampaignSlice = createSlice({
  name: "wabaCampaign",
  initialState: {
    campaigns: [],
    count: 0,
    cachedPages: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      /* ================= FETCH ================= */
      .addCase(fetchCampaigns.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCampaigns.fulfilled, (state, action) => {
        state.loading = false;
        const { campaigns, count, fromCache, cacheKey } = action.payload;
        if (!fromCache && cacheKey) {
          state.cachedPages[cacheKey] = { data: campaigns, count, ts: Date.now() };
        }
        state.campaigns = campaigns;
        state.count = count;
      })
      .addCase(fetchCampaigns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ================= ADD ================= */
     .addCase(addCampaign.pending, (state) => {
  state.loading = true;
})
.addCase(addCampaign.fulfilled, (state, action) => {
  state.loading = false;

  if (action.payload?.campaignId) {
    state.campaigns.unshift(action.payload);
    state.count += 1;
  }
})
.addCase(addCampaign.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})

      /* ================= DELETE ================= */
      .addCase(deleteCampaign.fulfilled, (state, action) => {
        state.campaigns = state.campaigns.filter(
          (c) => c.campaignId !== action.payload
        );
        state.count -= 1;
      });
  },
});

export default wabaCampaignSlice.reducer;
